"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _layout = require("../../layout");

var _text = require("../../text");

var _utils = require("../../utils");

var _interfaces = require("../interfaces");

var _DateMarkerLegendEntry = _interopRequireDefault(require("./DateMarkerLegendEntry"));

var _MarkerExample = require("./MarkerExample");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _interfaces2 = require("./interfaces");

var _core = require("@emotion/core");

var _excluded = ["disabledDescription", "markers", "titleText", "layout"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DateMarkerLegendWithoutDocs = function DateMarkerLegendWithoutDocs(_ref) {
  var disabledDescription = _ref.disabledDescription,
      _ref$markers = _ref.markers,
      markers = _ref$markers === void 0 ? _constants.defaultProps.markers : _ref$markers,
      titleText = _ref.titleText,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? _interfaces2.DateMarkerLegendLayout.Vertical : _ref$layout,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (markers.length === 0 && !disabledDescription) {
    return null;
  }

  var dateMarkerLegendId = (0, _utils.getUniqueId)('date-picker-legend');
  var dataProps = (0, _utils.pickDataProps)(forwardedProps);
  var hasTitle = !!titleText;
  return (0, _core.jsx)(_layout.View, null, hasTitle && (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_text.H3, {
    color: "neutral70",
    fontSize: "T300",
    id: dateMarkerLegendId
  }, titleText), (0, _core.jsx)(_layout.Spacer, {
    height: "S300"
  })), (0, _core.jsx)(_helperComponents.DateMarkerLegendUl, (0, _extends2.default)({
    layout: layout,
    "aria-labelledby": hasTitle ? dateMarkerLegendId : undefined,
    role: "list"
  }, dataProps), markers.map(function (_ref2) {
    var type = _ref2.type,
        descriptionText = _ref2.descriptionText;
    return (0, _core.jsx)(_DateMarkerLegendEntry.default, {
      descriptionText: descriptionText,
      key: type,
      markerExample: (0, _core.jsx)(_MarkerExample.MarkerExample, {
        type: type
      })
    });
  }), !!disabledDescription && (0, _core.jsx)(_DateMarkerLegendEntry.default, {
    descriptionText: disabledDescription,
    markerExample: (0, _core.jsx)(_MarkerExample.DisabledMarkerExample, null)
  })));
};

var DateMarkerLegendWithDocs = (0, _stencilReactDesc.describe)(DateMarkerLegendWithoutDocs).description('Legend for explaining what date markers represent.');
DateMarkerLegendWithDocs.propTypes = {
  disabledDescription: _stencilReactDesc.PropTypes.string.description('Description to display for the icon representing disabled dates. This only needs to be set if the date picker referenced by this legend has disabled dates.'),
  markers: _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.shape({
    type: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.DateMarkerType)),
    descriptionText: _stencilReactDesc.PropTypes.string
  })).description('Array of date markers, along with their descriptions. This array only needs to include markers which actually appear in the date picker referenced by this legend.'),
  titleText: _stencilReactDesc.PropTypes.string.description('Title to display above the date markers list.'),
  layout: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces2.DateMarkerLegendLayout)).description('The Layout of the markers list.')
};
var DateMarkerLegend = (0, _utils.withTestAttributes)({
  component: 'StencilDateMarkerLegend'
})(DateMarkerLegendWithDocs);
DateMarkerLegend.defaultProps = _objectSpread({}, _constants.defaultProps);
DateMarkerLegend.displayName = 'DateMarkerLegend';
var _default = DateMarkerLegend;
exports.default = _default;